import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { OfferBalanceAffiliateBilling } from "types/enums";

interface UseAffiliateBillingSelectOptionsParams {
    includeTenantSettingOption?: boolean;
}

export const useAffiliateBillingSelectOptions = ({
    includeTenantSettingOption = false,
}: UseAffiliateBillingSelectOptionsParams = {}) => {
    const { t } = usePaldockTranslation("forms.general-options.affiliate_billing");

    const options = [
        ...(includeTenantSettingOption
            ? [{ label: t("tenant_setting"), value: OfferBalanceAffiliateBilling.TenantSetting }]
            : []),
        { label: t("uninvoiced_balance"), value: OfferBalanceAffiliateBilling.UninvoicedBalance },
        { label: t("invoiced_balance"), value: OfferBalanceAffiliateBilling.InvoicedBalance },
        { label: t("approved_balance"), value: OfferBalanceAffiliateBilling.ApprovedBalance },
        { label: t("paid_balance"), value: OfferBalanceAffiliateBilling.PaidBalance },
    ];

    return { options, loading: false, error: null };
};
